import { createFileRoute } from "@tanstack/react-router";
import { SlidersHorizontal } from "lucide-react";
import {
  bufferPolicyQuery,
  holdPolicyQuery,
  waitlistPolicyQuery,
} from "@/api/policies";
import { warmQueries } from "@/api/warm";
import { useAuth } from "@/auth/AuthProvider";
import { PoliticasSection } from "@/components/configuracoes/PoliticasSection";
import { SettingsCard } from "@/components/configuracoes/SettingsCard";

export const Route = createFileRoute("/_authed/configuracoes/agendamento")({
  loader: ({ context: { queryClient, establishmentId } }) =>
    warmQueries(queryClient, [
      holdPolicyQuery(establishmentId),
      waitlistPolicyQuery(establishmentId),
      bufferPolicyQuery(establishmentId),
    ]),
  staticData: {
    title: "Agendamento",
    subtitle: "Prazos e intervalos que a agenda e o bot aplicam sozinhos.",
  },
  component: AgendamentoPage,
});

function AgendamentoPage() {
  const { user } = useAuth();
  if (!user) return null;

  return (
    <div className="space-y-6">
      <SettingsCard
        icon={SlidersHorizontal}
        title="Políticas operacionais"
        description="Antecedência mínima, janela de cancelamento e intervalo entre horários."
      >
        <PoliticasSection establishmentId={user.establishment_id} />
      </SettingsCard>
    </div>
  );
}
